module.exports = __webpack_public_path__ + "static/media/wave.340dd7c3.gif";